import React, {useEffect, useState} from 'react';
import { NavLink } from 'react-router-dom';
import '@deere/ux.uxframe-core/dist/css/uxframe-2019.3.0.min.css';
import { ListItem, SideNav } from '@deere/ux.uxframe-react';

function CustomSideNav(props) {
  return (
      <div style={{paddingLeft:'25px', paddingTop:'15px'}}>
          <SideNav ariaLabel="Web Standards Navigation">
              <ListItem className="nav-item">
                  <NavLink exact to="/" className="nav-link" activeClassName="active">
                      Registration
                  </NavLink>
              </ListItem>
              {/*<ListItem className="nav-item">
        <NavLink to="/CutReg/admin" className="nav-link" activeClassName="active">
          Admin
        </NavLink>
      </ListItem>*/}
          </SideNav>
      </div>
  );
}
export default CustomSideNav;
